export function pageWebSocketUrl(
  path: string,
  location: Pick<Location, 'protocol' | 'host'> = window.location,
): string {
  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${protocol}//${location.host}${normalized}`;
}
